import React from 'react';
import { hashHistory } from 'react-router';
import { Button, Table } from 'react-bootstrap';
import '../css/main.css';

export default class MaintenanceAuditComponent extends React.Component {

    // constructor(props) {
    //     super(props);
    // }

    componentWillMount() {
        this.props.findAuditableMCases();
    }

    auditMaintenanceCase(mcase) {
        this.props.assignModifyingTarget(mcase);
        hashHistory.push("/auditingCards");
    }

    appendMaintenanceDetails(mcase) {
        this.props.assignModifyingTarget(mcase);
        hashHistory.push("/auditingAppend");
    }

    render() {

        let caseStatus = function (statusKey) {
            switch (statusKey) {
                case 'FIXING': return '可部分檢點';
                case 'FIXED': return '可檢點';
                case 'AUDITED': return '檢點完成';
                default: return '';
            }
        }

        let highlight = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFE8BF",//yellow
                        verticalAlign: "middle"
                    };
                case 'FIXED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#FFBFBF",//red
                        verticalAlign: "middle"
                    };
                case 'AUDITED':
                    return {
                        textAlign: "center",
                        backgroundColor: "#EBEBFF",//blue
                        verticalAlign: "middle"
                    };
                default:
                    return {};
            }
        }

        let highlightClassName = function (statusKey) {
            switch (statusKey) {
                case 'FIXING':
                    return "highlight-brown";
                case 'FIXED':
                    return "highlight-red";
                case 'AUDITED':
                    return "highlight-blue";
                default:
                    return '';
            }
        }

        let alignCenter = {
            textAlign: "center",
            verticalAlign: "middle"
        }
        return (
            <div>
                <h4>檢點作業</h4><span hidden>MaintenanceAuditComponent </span>
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>訂單編號</th>
                            <th>客戶</th>
                            <th>Note</th>
                            <th>檢點</th>
                            <th>狀態</th>
                            <th>建立時間</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.response.get('cases').map(
                            (item, index) =>
                                <tr key={index}>
                                    <td style={alignCenter}>
                                        {item.orderId}
                                    </td>
                                    <td style={alignCenter}>
                                        {item.customer.customerName}
                                    </td>
                                    <td style={alignCenter}>
                                        {item.note}
                                    </td>
                                    <td style={alignCenter}>
                                        <Button bsStyle="info"
                                            onClick={(event) => { this.auditMaintenanceCase(item); }} >開始檢點</Button>&nbsp;&nbsp;
                                        {/* <Button bsStyle="warning"
                                            onClick={(event) => { this.appendMaintenanceDetails(item); }} >增補項目</Button> */}
                                    </td>
                                    <td style={highlight(item.status)}
                                        className={highlightClassName(item.status)} >
                                        {caseStatus(item.status)}
                                    </td>
                                    <td style={alignCenter}>
                                        {new Date(item.createTime).toLocaleDateString()}
                                    </td>
                                </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceAuditComponent.jsx